import React from "react";
import { Container} from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SectionTitle from "../SectionTitle";
import Reveal from "../Reveal";
// Projects pictures
import portfolio from "../../Assets/Projects/portfolio.png";
import subaligator from "../../Assets/Projects/subaligator.png";
import dblifez from "../../Assets/Projects/dblifez.png";
import assarceaux from "../../Assets/Projects/assarceaux.png";
import chainbreaker from "../../Assets/Projects/chainbreaker.png";

function Projects() {
    const responsive = {
        desktop: {
            breakpoint: { max: 100000, min: 768 },
            items: 3,
            slidesToSlide: 3
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };

    const projects = [
        {
            name: "ChainBreaker",
            image: chainbreaker,
            description:
                "Application React/TypeScript et Node.js connectée à Strava qui attribue un rang aux cyclistes à la manière d'un RPG.",
            url: "https://chain-breaker-beige.vercel.app/demo",
        },
        {
            name: "As Sarceaux",
            image: assarceaux,
            description:
                "Site fait en React pour le club de football de l'As Sarceaux. Fait avec <a href='https://www.linkedin.com/in/sacha-desquesnes/' target='_blank' rel='noopener noreferrer'>Sacha Desquesnes</a>",
            url: "https://as-sarceaux.vercel.app",
        },
        {
            name: "Mon site",
            image: portfolio,
            description: "Site fait en React et en Node.js pour me présenter ainsi que mes compétences.",
            url: "https://samuelaunay.vercel.app",
        },
        {
            name: "Sub'Alligator",
            image: subaligator,
            description:
                "Site fait en PHP natif et HTML, ce site permet d’évaluer les candidats aux brevets de plongée chez Sub'Alligator.",
            url: "",
        },
        {
            name: "DB Life Z",
            image: dblifez,
            description:
                "Site fait en HTML/CSS natif à mes débuts pour présenter un serveur Minecraft roleplay dans l’univers de Dragon Ball Z.",
            url: "",
        },
    ];

  return (
    <Container fluid className="project-section">
        <Container>
            <SectionTitle index="03" title="Mes projets" />
            <Carousel responsive={responsive} itemClass="project-slide">
                {projects.map((project, idx) => {
                    const image = (
                        <div className="project-image-wrap">
                            <img
                                src={project.image}
                                alt={project.name}
                                className="project-image"
                            />
                            {project.url && <span className="project-cta">Voir le site ↗</span>}
                        </div>
                    );
                    return (
                        <Reveal key={project.name} delay={idx * 120}>
                            <div className="project-container">
                                <span className="project-index">{String(idx + 1).padStart(2, "0")}</span>
                                <p className="project-name">{project.name}</p>
                                {project.url ? (
                                    <a href={project.url} target="_blank" rel="noopener noreferrer">
                                        {image}
                                    </a>
                                ) : (
                                    image
                                )}
                                <p className="project-desc" dangerouslySetInnerHTML={{ __html: project.description }}></p>
                            </div>
                        </Reveal>
                    );
                })}
            </Carousel>
        </Container>
    </Container>
  );
}

export default Projects;
